// Bump this on every release. Shown in Settings and used to invalidate
// the service worker cache (the constant is read inside sw.js too via the
// /sw.js cache-buster query string).
export const APP_VERSION = "0.7.1";
